let counter = 0;

export function useId(prefix = "v-id") {
    return `${prefix}-${++counter}`;
}
